import { create } from 'zustand'

import type { AuthUser } from '@/types/auth'

type AuthStatus = 'idle' | 'authenticated' | 'unauthenticated'

interface AuthState {
  user: AuthUser | null
  status: AuthStatus
  setSession: (user: AuthUser) => void
  clearSession: () => void
}

/**
 * Sanctum SPA auth is cookie-based (httpOnly session cookie) — there is no
 * bearer token to persist here. This store only mirrors "who is the current
 * user" as fetched from /api/v1/auth/me on app boot; it is intentionally not
 * persisted to localStorage to avoid stale or spoofable client-side identity.
 */
export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  status: 'idle',
  setSession: (user) => set({ user, status: 'authenticated' }),
  clearSession: () => set({ user: null, status: 'unauthenticated' }),
}))
